import { render, staticRenderFns } from "./BaseHeaderAccount.vue?vue&type=template&id=17b4dead&"
import script from "./BaseHeaderAccount.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderAccount.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports